import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "related-item-line ontos-inset" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ontos_color_accent = _resolveComponent("ontos-color-accent")!
  const _component_ontos_property_value = _resolveComponent("ontos-property-value")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ontos_color_accent, {
      vertical: "",
      class: "related-item-line-accent",
      color: _ctx.instanceColorOf(_ctx.item)
    }, null, 8, ["color"]),
    _createVNode(_component_ontos_property_value, {
      class: "text-body-1",
      property: _ctx.property,
      value: _ctx.item,
      context: _ctx.context,
      variant: "detail",
      accent: false,
      onLink: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('link', $event)))
    }, null, 8, ["property", "value", "context"])
  ]))
}